import { Circle, Flex, useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import { FaFacebook, FaGithub, FaTwitter } from 'react-icons/fa'

const Footer = () => {
  const bg = useColorModeValue("#1a0e2c36","#c1c1c436")
  const color = useColorModeValue("#1a0e2c","#c1c1c4")
  return (
    <Flex width="90%" margin="0 auto" pb="0px">
        <Circle
        background={bg}
        padding="4px"
        cursor="pointer"
        >
            <FaTwitter
        color={color}
        fontSize="14px"
        
        /> 
        </Circle>
        <Circle
        background={bg}
        padding="4px"
        cursor="pointer"
        mx="10px"
        >
            <FaFacebook
        color={color}
        fontSize="14px"
        
        /> 
        </Circle>
        <Circle
        background={bg}
        padding="4px"
        cursor="pointer"
        >
            <FaGithub
        color={color}
        fontSize="14px"
        
        /> 
        </Circle>
    </Flex>
  )
}

export default Footer